"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFQView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var Draft_1 = __importDefault(require("../../Discussion/Draft"));
var useReducer_1 = __importDefault(require("../utils/useReducer"));
var RFQGrid_1 = require("./RFQGrid");
var RFQReducer_1 = require("./RFQReducer");
var RFQView = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var t = (0, react_i18next_1.useTranslation)().t;
    var RFQId = useParams().match.params.RFQId;
    var _h = (0, firestore_1.useDocument)(collectionsRef_1.RFQsRef.doc(RFQId)), RFQSnapshot = _h[0], RFQSnapshotLoading = _h[1];
    var RFQData = ((_a = RFQSnapshot === null || RFQSnapshot === void 0 ? void 0 : RFQSnapshot.data()) !== null && _a !== void 0 ? _a : {});
    var _j = (0, firestore_1.useCollectionOnce)(collectionsRef_1.RFQItemsRef.where("RFQId", "==", RFQId)), RFQItemsSnapshot = _j[0], RFQitemsSnapshotLoading = _j[1];
    var _k = (0, firestore_1.useCollectionOnce)(collectionsRef_1.IRItemsRef.where("IRId", "==", (_b = RFQData.irId) !== null && _b !== void 0 ? _b : "")), IRItemsSnapshot = _k[0], IRitemsSnapshotLoading = _k[1];
    var _l = (0, firestore_1.useDocument)(collectionsRef_1.IRsRef.doc((_c = RFQData === null || RFQData === void 0 ? void 0 : RFQData.irId) !== null && _c !== void 0 ? _c : "id")), IRSnapshot = _l[0], IRloading = _l[1];
    var IRData = ((_d = IRSnapshot === null || IRSnapshot === void 0 ? void 0 : IRSnapshot.data()) !== null && _d !== void 0 ? _d : {});
    var RFQItems = ((_e = RFQItemsSnapshot === null || RFQItemsSnapshot === void 0 ? void 0 : RFQItemsSnapshot.docs) !== null && _e !== void 0 ? _e : []).map(function (doc) {
        return __assign(__assign({}, doc.data()), { id: doc.id });
    });
    var IRItems = ((_f = IRItemsSnapshot === null || IRItemsSnapshot === void 0 ? void 0 : IRItemsSnapshot.docs) !== null && _f !== void 0 ? _f : []).map(function (doc) {
        return __assign(__assign({}, doc.data()), { id: doc.id });
    });
    var router = useParams();
    var _m = (0, useReducer_1.default)((0, RFQReducer_1.getRFQReducer)(router, t), null), state = _m[0], dispatch = _m[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var supplierSn, _a, supplier, data;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (RFQSnapshotLoading ||
                            RFQitemsSnapshotLoading ||
                            IRitemsSnapshotLoading ||
                            state ||
                            !RFQData ||
                            IRloading ||
                            !IRData) {
                            return [2 /*return*/];
                        }
                        if (!(RFQData === null || RFQData === void 0 ? void 0 : RFQData.supplierId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, collectionsRef_1.suppliersRef.doc((_b = RFQData === null || RFQData === void 0 ? void 0 : RFQData.supplierId) !== null && _b !== void 0 ? _b : "id").get()];
                    case 1:
                        _a = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        supplierSn = _a;
                        supplier = supplierSn
                            ? __assign(__assign({}, supplierSn.data()), { id: supplierSn.id })
                            : undefined;
                        data = __assign(__assign({}, RFQData), { supplier: supplier, RFQItems: (0, lodash_1.sortBy)(RFQItems, function (x) { return x.index; }), irItems: IRItems, irId: RFQData.irId, irData: IRData, RFQId: RFQId, triedSubmitting: false });
                        dispatch({ type: "init", payload: data });
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [
        RFQSnapshotLoading,
        RFQitemsSnapshotLoading,
        RFQData,
        RFQItems,
        RFQId,
        state,
        IRloading,
        IRData,
        IRitemsSnapshotLoading,
        IRItems,
    ]);
    var projectId = (_g = state === null || state === void 0 ? void 0 : state.projectId) !== null && _g !== void 0 ? _g : "";
    var RFQParticipateInDiscussionPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "RFQParticipateInDiscussion",
    ]);
    var RFQViewDiscussionPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "RFQViewDiscussion",
    ]);
    if (RFQitemsSnapshotLoading || RFQSnapshotLoading || !state || IRloading) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, { size: "large" });
    }
    var mode = state.status === "draft" ? "edit" : "view";
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.orderContainer }, { children: [(0, jsx_runtime_1.jsx)(RFQGrid_1.RFQGrid, { state: state, dispatch: dispatch, mode: mode }), RFQViewDiscussionPermission ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(index_modules_css_1.default.orderSection, " ").concat(index_modules_css_1.default.orderFooter) }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t("common.discussion") }), (0, jsx_runtime_1.jsx)(Draft_1.default, { kind: "RFQ", docId: RFQId, viewInput: RFQParticipateInDiscussionPermission })] }))) : null] })));
};
exports.RFQView = RFQView;
exports.default = exports.RFQView;
